export class AzureFilesStorageAccountSelection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "includedFileShares",
            "baseName": "includedFileShares",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureFilesStorageAccountSelection.attributeTypeMap;
    }
    constructor() {
    }
}
